"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VIDEO_FORWARDING_MOBILE_MAX_VALUE = exports.VIDEO_FORWARDING_DESKTOP_MAX_VALUE = exports.isBrowser = exports.isBooleanConstraintEnabled = exports.makeVideoConstraints = exports.makeConstraints = exports.buildConstraints = void 0;
const config_1 = __importDefault(require("../config/config"));
const lodash_merge_1 = __importDefault(require("lodash.merge"));
const Helpers_1 = require("../models/Helpers");
/**
 * @ignore
 * @param predefinedConstraints
 * @param mixingEnabled
 * @returns {{audio: ({valueOf(): boolean}|boolean), video: ({valueOf(): boolean}|boolean)}|{audio: boolean, video: boolean}}
 */
exports.buildConstraints = ({ predefinedConstraints = { audio: true, video: false }, mixingEnabled = false } = {}) => {
    if (mixingEnabled)
        return { audio: false, video: false };
    const constraints = Helpers_1.isMobile() ? config_1.default.media.mobile.constraints : config_1.default.media.constraints;
    return Object.assign(Object.assign({}, constraints), { audio: typeof predefinedConstraints.audio === 'object'
            ? Object.assign(Object.assign({}, constraints.audio), predefinedConstraints.audio) : typeof predefinedConstraints.audio === 'boolean'
            ? predefinedConstraints.audio
            : false, video: typeof predefinedConstraints.video === 'object'
            ? Object.assign(Object.assign({}, constraints.video), predefinedConstraints.video) : typeof predefinedConstraints.video === 'boolean'
            ? predefinedConstraints.video
            : false });
};
/**
 * @deprecated
 * @ignore
 * @param {*} constraints
 * @param mixingOptions
 */
exports.makeConstraints = (constraints, mixingOptions) => {
    if (mixingOptions && mixingOptions.enabled) {
        return { audio: false, video: false };
    }
    let localConstraints = constraints || { audio: true, video: false };
    let newConstraints = {};
    lodash_merge_1.default(newConstraints, Helpers_1.isMobile() ? config_1.default.media.mobile.constraints : config_1.default.media.constraints);
    if (localConstraints.audio) {
        if (typeof localConstraints === 'object') {
            lodash_merge_1.default(newConstraints.audio, localConstraints.audio);
        }
    }
    else {
        newConstraints.audio = false;
    }
    if (localConstraints.video) {
        if (typeof localConstraints.video === 'object') {
            lodash_merge_1.default(newConstraints.video, localConstraints.video);
        }
    }
    else {
        newConstraints.video = false;
    }
    return newConstraints;
};
/**
 * @ignore
 * @param {*} constraints
 */
exports.makeVideoConstraints = (constraints) => {
    let newConstraints = Helpers_1.isMobile() ? config_1.default.media.mobile.constraints.video : config_1.default.media.constraints.video;
    lodash_merge_1.default(newConstraints, constraints);
    return newConstraints;
};
/**
 * @ignore
 */
exports.isBooleanConstraintEnabled = (constraints, name, defaultValue) => {
    if (!(name in constraints))
        return defaultValue;
    if (typeof constraints[name] !== 'object')
        return constraints[name];
    if ('exact' in constraints[name])
        return constraints[name].exact;
    if ('ideal' in constraints[name])
        return constraints[name].ideal;
    return false;
};
/**
 * Check this global scope without overrides
 * @ignore
 */
exports.isBrowser = new Function('try {return this===window;} catch(e) {return false;}');
/**
 * Default max video forwarding strategy for desktop browser
 * @ignore
 */
exports.VIDEO_FORWARDING_DESKTOP_MAX_VALUE = 25;
/**
 * Default max video forwarding strategy for mobile browser
 * @ignore
 */
exports.VIDEO_FORWARDING_MOBILE_MAX_VALUE = 4;
